import { render } from "./ActivePatients.vue?vue&type=template&id=4612cfa0&ts=true"
import script from "./ActivePatients.ts?vue&type=script&lang=ts&external"
export * from "./ActivePatients.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__